exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".districtOrgDetailsPage .sectionSubHeader{margin:1em 0 .3em}.districtOrgDetailsPage .buttonControls{text-align:center;padding:.5em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/wizards/district_org_accounts_page.scss
// module id = 823
// module chunks = 0